// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13W7a","clinicsSelect":"styles_clinicsSelect__3mPMP"};